import { Paper, Stack, Avatar, Typography, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { alert } from "src/services/alert";
import FormItem from "src/components/form-item/FormItem";
import UserInfo from "src/components/common/UserInfo";
import UserPicker from "src/components/common/UserPicker";
import { asyncRequest } from "src/services/network";
import FormDialog from "src/components/common/FormDialog";

const UserAddDialog = ({ open, onClose, onFinish, user }) => {
  const [parent, setParent] = useState({});

  const [form, setForm] = useState({
    mobile: "",
    nickname: "",
    points: "0",
    pointsXf: "0",
    pointsGreen: "0",
  });

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val.trim(),
    });
  }

  async function handleConfirm() {
    if (!form.mobile) return alert("请输入手机号"); 
    // if (Number.isNaN(parseFloat(form.amount))) return alert("数量不能为空");

    const { msg } = await asyncRequest({
      path: "/user/create",
      data: {
        ...form,
        pid: parent.uid,
      },
    });

    alert(msg, "success");
    onFinish();
  }

  function handlePickUser() {
    UserPicker({
      onSelect(v) {
        setParent(v);
      },
    });
  }

  return (
    <FormDialog title="创建用户" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="手机号">
        <TextField fullWidth type="number" placeholder="手机号" autoComplete="off" id="mobile" value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
      </FormItem>

      <FormItem title="昵称">
        <TextField fullWidth placeholder="昵称" autoComplete="off" id="nickname" value={form.nickname} size="small" onChange={(e) => handleIptChange("nickname", e.target.value)} />
      </FormItem>


      <FormItem title="推荐人">
        <Stack onClick={handlePickUser}>
          <UserInfo {...parent} enablePreview={false} />
        </Stack>
      </FormItem>
    </FormDialog>
  );
};

export default UserAddDialog;
